module.exports = __webpack_public_path__ + "static/media/arrow.042098be.svg";